import {RolePermission, RolePermissionCreate} from '@/types'
import apiClient from '@/utils/axios'
import {apiEndPoints} from '@/utils/constant'
import {AxiosResponse} from 'axios'

const {PERMISSION_ROLE_URL} = apiEndPoints

interface RolesPermissionService{
  getRolePermissions: () => Promise<AxiosResponse<RolePermission[]>>
  getRolePermissionById: (permissionsRoleId: number) => Promise<AxiosResponse<RolePermission>>
  postRolePermissions: (permissionsRole: RolePermissionCreate) => Promise<AxiosResponse<RolePermission>>
  deleteRolePermission: (permissionsRoleId: number) => Promise<AxiosResponse<string>>
}

const rolesPermission: RolesPermissionService = {
  async getRolePermissions(): Promise<AxiosResponse<RolePermission[]>> {
    const response = await apiClient.get(PERMISSION_ROLE_URL)
    return response
  },

  async getRolePermissionById(permissionsRoleId: number): Promise<AxiosResponse<RolePermission>> {
    const response = await apiClient.get(
      `${PERMISSION_ROLE_URL}/${permissionsRoleId}`,
    )
    return response
  },

  async postRolePermissions(permissionsRole: RolePermissionCreate): Promise<AxiosResponse<RolePermission>> {
    const response = await apiClient.post(
      PERMISSION_ROLE_URL, permissionsRole,
    )
    return response
  },

  async deleteRolePermission(permissionsRoleId: number): Promise<AxiosResponse<string>> {
    const response = await apiClient.delete(
      `${PERMISSION_ROLE_URL}/${permissionsRoleId}`,
    )
    return response
  },
}

export {rolesPermission}
